import { gdImgSrcPolicy } from "@/utils/imageUrl";
import classNames from "classnames";
import Image from "../Image";
import styles from "./index.module.less";

interface AvatarProps {
  org?: any;
  className?: string;
  imgUrl?: string;
  shape?: "square" | "circle";
  size?: number;
}
/**组织头像 */
export default function GDAvatar({
  org,
  shape = "square",
  size = 75,
  imgUrl,
  className,
}: AvatarProps) {
  return (
    <Image
      className={classNames(styles.avatar, styles[shape], className)}
      {...gdImgSrcPolicy(
        org?.company?.logo?.url ||
          imgUrl ||
          "https://st0.dancf.com/static/02/202208021126-631c.png",
        { displayWidth: size }
      )}
      alt={org?.company?.name}
      width={size}
      height={size}
    />
  );
}
